import { render, staticRenderFns } from "./SocialHistory.vue?vue&type=template&id=602f9ef8&"
import script from "./SocialHistory.vue?vue&type=script&lang=js&"
export * from "./SocialHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports